import { render, staticRenderFns } from "./DialogProject.vue?vue&type=template&id=392355ae"
import script from "./DialogProject.vue?vue&type=script&lang=js"
export * from "./DialogProject.vue?vue&type=script&lang=js"
import style0 from "./DialogProject.vue?vue&type=style&index=0&id=392355ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports